import { push } from 'react-router-redux';

import type { ICustomCategory } from '../domain';
import { endpoint } from '../helpers/Endpoints';
import Routes from '../helpers/Routes';
import type { IToastMessage } from '../helpers/Toastr';
import { toastr } from '../helpers/Toastr';
import type {
	ICustomCategoryForMaintenance,
	IEditCustomCategory,
	INewCustomCategory,
} from '../values';
import * as FetchAction from './FetchActionGeneric';
import type { DispatchFunc } from './types';

export const LOADING_CUSTOM_CATEGORIES = '@ccm:LOADING_CUSTOM_CATEGORIES';
export const LOADING_CUSTOM_CATEGORIES_SUCCESS =
	'@ccm:LOADING_CUSTOM_CATEGORIES_SUCCESS';
export const LOADING_CUSTOM_CATEGORIES_ERROR =
	'@ccm:LOADING_CUSTOM_CATEGORIES_ERROR';

export function loadCustomCategories() {
	return FetchAction.CreateFetchAction<ICustomCategoryForMaintenance>({
		startAction: LOADING_CUSTOM_CATEGORIES,
		method: 'GET',
		url: endpoint.customCategories(),
	});
}

export const LOADING_CUSTOM_CATEGORY = '@ccm:LOADING_CUSTOM_CATEGORY';
export const LOADING_CUSTOM_CATEGORY_SUCCESS =
	'@ccm:LOADING_CUSTOM_CATEGORY_SUCCESS';
export const LOADING_CUSTOM_CATEGORY_ERROR =
	'@ccm:LOADING_CUSTOM_CATEGORY_ERROR';

export function loadCustomCategory(customCategoryId: number) {
	return FetchAction.CreateFetchAction<ICustomCategory>({
		startAction: LOADING_CUSTOM_CATEGORY,
		method: 'GET',
		url: endpoint.customCategory(customCategoryId),
		onAfterSuccess: (data: ICustomCategory, dispatch: DispatchFunc) => {
			dispatch(setCustomCategory(data));
		},
	});
}

export const SET_CUSTOM_CATEGORY = '@ccm:SET_CUSTOM_CATEGORY';
export function setCustomCategory(customCategory: ICustomCategory) {
	return {
		type: SET_CUSTOM_CATEGORY,
		payload: customCategory,
	};
}

export const SUBMIT_NEW_CATEGORY = '@ccm:SUBMIT_NEW_CATEGORY';
export const SUBMIT_NEW_CATEGORY_SUCCESS = '@ccm:SUBMIT_NEW_CATEGORY_SUCCESS';
export const SUBMIT_NEW_CATEGORY_ERROR = '@ccm:SUBMIT_NEW_CATEGORY_ERROR';

export function saveNewCategory(
	request: INewCustomCategory,
	toastMessage: IToastMessage
) {
	return FetchAction.CreateFetchAction({
		startAction: SUBMIT_NEW_CATEGORY,
		method: 'POST',
		url: endpoint.customCategories(),
		body: JSON.stringify(request),
		onAfterSuccess: (data: number, dispatch: DispatchFunc) => {
			toastr.success(toastMessage);
			dispatch(push(Routes.customCategories.manageCustomCategories()));
		},
	});
}

export const SUBMIT_EDIT_CATEGORY = '@ccm:SUBMIT_EDIT_CATEGORY';
export const SUBMIT_EDIT_CATEGORY_SUCCESS = '@ccm:SUBMIT_EDIT_CATEGORY_SUCCESS';
export const SUBMIT_EDIT_CATEGORY_ERROR = '@ccm:SUBMIT_EDIT_CATEGORY_ERROR';

export function saveEditCategory(
	request: IEditCustomCategory,
	toastMessage: IToastMessage
) {
	return FetchAction.CreateFetchAction({
		startAction: SUBMIT_EDIT_CATEGORY,
		method: 'PUT',
		url: endpoint.customCategories(),
		body: JSON.stringify(request),
		onAfterSuccess: (data: number, dispatch: DispatchFunc) => {
			toastr.success(toastMessage);
			dispatch(push(Routes.customCategories.manageCustomCategories()));
		},
	});
}

export const DELETING_CUSTOM_CATEGORY = '@ccm:DELETING_CUSTOM_CATEGORY';
export const DELETING_CUSTOM_CATEGORY_SUCCESS =
	'@ccm:DELETING_CUSTOM_CATEGORY_SUCCESS';
export const DELETING_CUSTOM_CATEGORY_ERROR =
	'@ccm:DELETING_CUSTOM_CATEGORY_ERROR';

export function deleteCustomCategory(
	customCategoryId: number,
	onAfterSuccess: () => void
) {
	return FetchAction.CreateFetchAction<ICustomCategoryForMaintenance>({
		startAction: DELETING_CUSTOM_CATEGORY,
		method: 'DELETE',
		url: endpoint.customCategory(customCategoryId),
		onAfterSuccess,
	});
}
